module.exports = __webpack_public_path__ + "img/submit-button.0fe1e486.png";